import { render } from "./ChatWidget.vue?vue&type=template&id=71396ffa&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"

import "./ChatWidget.vue?vue&type=style&index=0&id=71396ffa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71396ffa"]])

export default __exports__